import { navigateTo } from '@max/meituan-uni-navigate';
import { getPlatformType, isMiniProgramOrWebview, PlatformType } from '@nibfe/mkt-env-api';
export default function navigateToPage(link) {
    if (isMiniProgramOrWebview() && getPlatformType() === PlatformType.mtHotelMinaWebview) {
        navigateTo({
            url: `/pages/navigator/index?appId=wxde8ac0a21135c07d&path=${encodeURIComponent(link)}`,
            _web: {
                miniProgramNative: true
            }
        });
    }
    else {
        navigateTo({
            url: link,
            _web: {
                miniProgramNative: true
            }
        });
    }
}
